import * as React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';

type Props = {
    children: React.ReactElement;
};

export default function PrivateRoute({ children }: Props) {
    const location = useLocation();
    const parsed = queryString.parse(location.search);
    const isAuthenticated = parsed.ath === 'true';
    // const isAuthenticated = true;


    if (isAuthenticated) {
        return children;
    }

    return (
        <Navigate
            to={{ pathname: '/verify', search: location.search }}
            replace
            state={{ from: location }}
        />
    );
}
